<template>
    <div>
        <!-- Tabs -->
        <el-tabs v-model="activeName" type="border-card" v-loading="loading">
          <!-- 复查列表 strat -->
          <el-tab-pane label="复查列表" name="first">
            <div class="block">
                <el-button type="info" class="mt20" @click="backCustomerManagement">返回</el-button>
                <el-button type="primary" @click="clickexcel" v-if="SubRule_ExcelFuCha">导出Excel</el-button>
            </div>

            <el-table :data="visionCheckData" border stripe class="mt15">
                <el-table-column prop="Checkname" label="检查人员姓名" width="70px"></el-table-column>
                <el-table-column prop="Inputname" label="录入人员姓名" width="70px"></el-table-column>
                <el-table-column prop="Inputtime" label="录入时间" width="100px"></el-table-column>
                <el-table-column prop="Datatype" label="录入类型" width="60px"></el-table-column>
                <el-table-column prop="Diopterstate" label="屈光状态" width="50px"></el-table-column>
                <el-table-column prop="Interpupillary" label="瞳距" width="50px"></el-table-column>
                <el-table-column prop="Add" label="ADD" width="50px"></el-table-column>
                <el-table-column prop="Amp" label="调节幅度" width="50px"></el-table-column>
                <el-table-column prop="Righteyedegree" label="球镜OD(右眼)" width="60px"></el-table-column>
                <el-table-column prop="Lefteyedegree" label="球镜OS(左眼)" width="60px"></el-table-column>
                <el-table-column prop="Rightcolumnmirror" label="柱镜OD(右眼)" width="60px"></el-table-column>
                <el-table-column prop="Leftcolumnmirror" label="柱镜OS(左眼)" width="60px"></el-table-column>
                <el-table-column prop="Rightaxial" label="轴向OD(右眼)" width="60px"></el-table-column>
                <el-table-column prop="Leftaxial" label="轴向OS(左眼)" width="60px"></el-table-column>
                <el-table-column prop="Nakedrighteyedegree" label="裸眼视力OD(右眼)" width="70px"></el-table-column>
                <el-table-column prop="Nakedlefteyedegree" label="裸眼视力OS(左眼)" width="70px"></el-table-column>
                <el-table-column prop="Nakedbinoculusdegree" label="裸眼视力OU(双眼)" width="70px"></el-table-column>
                <el-table-column prop="Correctrighteyedegree" label="最佳矫正视力OD(右眼)" width="70px"></el-table-column>
                <el-table-column prop="Correctlefteyedegree" label="最佳矫正视力OS(左眼)" width="70px"></el-table-column>
                <el-table-column prop="Correctbinoculusdegree" label="最佳矫正视力OU(双眼)" width="70px"></el-table-column>
                <el-table-column prop="Neizhitjggright" label="内置透镜规格(右眼)" width="70px"></el-table-column>
                <el-table-column prop="Neizhitjggleft" label="内置透镜规格(左眼)" width="70px"></el-table-column>
                <el-table-column prop="Adminname" label="管理员姓名" width="60px"></el-table-column>
                <el-table-column prop="operation" label="操作">
                  <template v-slot="scope">
                    <el-button type="text" size="mini" style="margin-left: 0; margin-right: 6px" v-if="SubRule_Customer_ModifyEyeInfo" @click="clickm(scope.row)">修改</el-button>
                  </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="pages">
              <el-pagination
                @current-change="handleCurrentPageChange"
                :page-size="10"
                layout="total, prev, pager, next, jumper"
                :total="dataListnum"
                :current-page.sync="selectedPageNo">
              </el-pagination>
            </div>
          </el-tab-pane>
          <!-- 复查列表 end -->

          <!-- 添加视力复查 start -->
          <el-tab-pane label="添加视力复查" name="second" v-if="SubRule_Customer_AddEyeInfo">
            <el-form :model="addCustomer" ref="addCustomerRef" label-width="68px">
              <el-form-item label="检查人员" class="addAdminForm">
                <el-input v-model="addCustomer.checkname" placeholder="请输入姓名"></el-input>
              </el-form-item>
              <el-form-item label="录入人员" class="addAdminForm">
                <el-input v-model="addCustomer.inputname" placeholder="请输入姓名"></el-input>
              </el-form-item>
              <el-form-item label="录入时间" class="addAdminForm">
                <el-date-picker v-model="addCustomer.inputtime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
              </el-form-item>

              <div class="optometry">
                <el-form-item label="屈光状态" class="select2">
                  <el-select v-model="addCustomer.diopterstate" placeholder="请选择" style="width: 100%">
                    <el-option label="请选择" value="0"></el-option>
                    <el-option label="正视" value="6"></el-option>
                    <el-option label="远视" value="2"></el-option>
                    <el-option label="近视" value="1"></el-option>
                    <el-option label="散光" value="7"></el-option>
                    <el-option label="老花" value="3"></el-option>
                    <el-option label="屈光参差" value="8"></el-option>
                    <el-option label="远视性弱视" value="9"></el-option>
                    <el-option label="散光性弱视" value="10"></el-option>
                    <el-option label="近视性弱视" value="11"></el-option>
                  </el-select>
                </el-form-item>
              </div>
              <!-- 视光信息 end -->

              <!-- 屈光度 -->
              <el-table :data="diopterData" border stripe class="mt20">
                <el-table-column label="屈光度" align="center">
                  <el-table-column label="OD(右眼)" align="center">
                    <el-table-column prop="rightEye1" label="右眼球镜(范围:-15.00D~+5.00D)">
                      <template slot-scope="scope">
                        <el-input v-model="addCustomer.righteyedegree" class="input_num"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="rightEye2" label="右眼柱镜(范围:-5.00D~+5.00D)">
                      <template slot-scope="scope">
                        <el-input v-model="addCustomer.rightcolumnmirror" class="input_num"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="rightEye3" label="右眼轴向(范围:0~+180)">
                      <template slot-scope="scope">
                        <el-input v-model="addCustomer.rightaxial" class="input_num"></el-input>
                      </template>
                    </el-table-column>
                  </el-table-column>
                  <el-table-column label="OS(左眼)" align="center">
                    <el-table-column prop="leftEye1" label="左眼球镜(范围:-15.00D~+5.00D)">
                      <template slot-scope="scope">
                        <el-input v-model="addCustomer.lefteyedegree" class="input_num"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="leftEye2" label="左眼柱镜(范围:-5.00D~+5.00D)">
                      <template slot-scope="scope">
                        <el-input v-model="addCustomer.leftcolumnmirror" class="input_num"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="leftEye3" label="左眼轴向(范围:0~+180)">
                      <template slot-scope="scope">
                        <el-input v-model="addCustomer.leftaxial" class="input_num"></el-input>
                      </template>
                    </el-table-column>
                  </el-table-column>
                </el-table-column>
              </el-table>

              <!-- ADD和调节幅度 -->
              <el-table :data="addData" border stripe class="mt20">
                <el-table-column label="ADD和调节幅度" align="center">
                  <el-table-column prop="add" label="ADD(范围:0.00D~+5.00D)">
                    <template slot-scope="scope">
                      <el-select v-model="addCustomer.addtype" placeholder="请选择" style="width: 100%">
                        <el-option label="0.00D" value="0"></el-option>
                        <el-option label="0.50D" value="1"></el-option>
                        <el-option label="0.75D" value="2"></el-option>
                        <el-option label="1.00D" value="3"></el-option>
                        <el-option label="1.25D" value="4"></el-option>
                        <el-option label="1.50D" value="5"></el-option>
                        <el-option label="1.75D" value="6"></el-option>
                        <el-option label="2.00D" value="7"></el-option>
                        <el-option label="2.25D" value="8"></el-option>
                        <el-option label="2.50D" value="9"></el-option>
                        <el-option label="2.75D" value="10"></el-option>
                        <el-option label="3.00D" value="11"></el-option>
                        <el-option label="3.25D" value="12"></el-option>
                        <el-option label="3.50D" value="13"></el-option>
                        <el-option label="3.75D" value="14"></el-option>
                        <el-option label="4.00D" value="15"></el-option>
                        <el-option label="4.25D" value="16"></el-option>
                        <el-option label="4.50D" value="17"></el-option>
                        <el-option label="4.75D" value="18"></el-option>
                        <el-option label="5.00D" value="19"></el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column prop="adjust" label="调节幅度(范围:0.00D~+22.00D)">
                    <template slot-scope="scope">
                      <el-input v-model="addCustomer.amp"></el-input>
                    </template>
                  </el-table-column>
                </el-table-column>
              </el-table>

              <!-- 裸眼和矫正视力 -->
              <el-table :data="nakedEye" border stripe class="mt20">
                <el-table-column label="5m裸眼视力(5分记录法)" align="center">
                  <el-table-column prop="odRight" label="OD(右眼)">
                    <template slot-scope="scope">
                      <el-select v-model="addCustomer.nakedrighteyedegree" placeholder="请选择">
                        <el-option
                          v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column prop="osLeft" label="OS(左眼)">
                    <template slot-scope="scope">
                      <el-select v-model="addCustomer.nakedlefteyedegree" placeholder="请选择">
                        <el-option
                          v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column prop="ouDouble" label="OU(双眼)">
                    <template slot-scope="scope">
                      <el-select v-model="addCustomer.nakedbinoculusdegree" placeholder="请选择">
                        <el-option
                          v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                </el-table-column>

                <el-table-column label="最佳矫正视力(5分记录法)" align="center">
                  <el-table-column prop="odRight1" label="OD(右眼)">
                    <template slot-scope="scope">
                      <el-select v-model="addCustomer.correctrighteyedegree" placeholder="请选择">
                        <el-option
                          v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column prop="osLeft1" label="OS(左眼)">
                    <template slot-scope="scope">
                      <el-select v-model="addCustomer.correctlefteyedegree" placeholder="请选择">
                        <el-option
                          v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column prop="ouDouble1" label="OU(双眼)">
                    <template slot-scope="scope">
                      <el-select v-model="addCustomer.correctbinoculusdegree" placeholder="请选择">
                        <el-option
                          v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                </el-table-column>
              </el-table>

              <!-- 瞳距，内透镜规格 -->
              <el-table :data="tongJuData" border stripe class="mt20">
                <el-table-column  prop="tongju" label="瞳距(单位:mm)">
                  <template slot-scope="scope">
                    <el-input v-model="addCustomer.interpupillary"></el-input>
                  </template>
                </el-table-column>
                  <el-table-column label="内置透镜规格(右眼)">
                    <template slot-scope="scope">
                      <el-select v-model="addCustomer.neizhitjggright" placeholder="请选择">
                        <el-option
                          v-for="item in neizhitjgglist" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column label="内置透镜规格(左眼)">
                    <template slot-scope="scope">
                      <el-select v-model="addCustomer.neizhitjggleft" placeholder="请选择">
                        <el-option
                          v-for="item in neizhitjgglist" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
              </el-table>

              <el-form-item class="mt20">
                <el-button type="primary" @click="clickAdd">保存</el-button>
                <el-button type="info" @click="clickreturn1">返回</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <!-- 添加视力复查 end -->

          <!-- 修改视力复查 start -->
          <el-tab-pane label="修改视力复查" name="three" v-if="Display_ModifyEyeInfo">
            <el-form :model="editfucha" ref="editfuchaRef" label-width="68px">
              <el-form-item label="检查人员" class="addAdminForm">
                <el-input v-model="editfucha.checkname" placeholder="请输入姓名"></el-input>
              </el-form-item>
              <el-form-item label="录入人员" class="addAdminForm">
                <el-input v-model="editfucha.inputname" placeholder="请输入姓名"></el-input>
              </el-form-item>
              <el-form-item label="录入时间" class="addAdminForm">
                <el-date-picker v-model="editfucha.inputtime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
              </el-form-item>

              <div class="optometry">
                <el-form-item label="屈光状态" class="select2">
                  <el-select v-model="editfucha.diopterstate" placeholder="请选择" style="width: 100%">
                    <el-option label="请选择" value="0"></el-option>
                    <el-option label="正视" value="6"></el-option>
                    <el-option label="远视" value="2"></el-option>
                    <el-option label="近视" value="1"></el-option>
                    <el-option label="散光" value="7"></el-option>
                    <el-option label="老花" value="3"></el-option>
                    <el-option label="屈光参差" value="8"></el-option>
                    <el-option label="远视性弱视" value="9"></el-option>
                    <el-option label="散光性弱视" value="10"></el-option>
                    <el-option label="近视性弱视" value="11"></el-option>
                  </el-select>
                </el-form-item>
              </div>
              <!-- 视光信息 end -->

              <!-- 屈光度 -->
              <el-table :data="diopterData" border stripe class="mt20">
                <el-table-column label="屈光度" align="center">
                  <el-table-column label="OD(右眼)" align="center">
                    <el-table-column prop="rightEye1" label="右眼球镜(范围:-15.00D~+5.00D)">
                      <template slot-scope="scope">
                        <el-input v-model="editfucha.righteyedegree" class="input_num"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="rightEye2" label="右眼柱镜(范围:-5.00D~+5.00D)">
                      <template slot-scope="scope">
                        <el-input v-model="editfucha.rightcolumnmirror" class="input_num"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="rightEye3" label="右眼轴向(范围:0~+180)">
                      <template slot-scope="scope">
                        <el-input v-model="editfucha.rightaxial" class="input_num"></el-input>
                      </template>
                    </el-table-column>
                  </el-table-column>
                  <el-table-column label="OS(左眼)" align="center">
                    <el-table-column prop="leftEye1" label="左眼球镜(范围:-15.00D~+5.00D)">
                      <template slot-scope="scope">
                        <el-input v-model="editfucha.lefteyedegree" class="input_num"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="leftEye2" label="左眼柱镜(范围:-5.00D~+5.00D)">
                      <template slot-scope="scope">
                        <el-input v-model="editfucha.leftcolumnmirror" class="input_num"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="leftEye3" label="左眼轴向(范围:0~+180)">
                      <template slot-scope="scope">
                        <el-input v-model="editfucha.leftaxial" class="input_num"></el-input>
                      </template>
                    </el-table-column>
                  </el-table-column>
                </el-table-column>
              </el-table>

              <!-- ADD和调节幅度 -->
              <el-table :data="addData" border stripe class="mt20">
                <el-table-column label="ADD和调节幅度" align="center">
                  <el-table-column prop="add" label="ADD(范围:0.00D~+5.00D)">
                    <template slot-scope="scope">
                      <el-select v-model="editfucha.addtype" placeholder="请选择" style="width: 100%">
                        <el-option label="0.00D" value="0"></el-option>
                        <el-option label="0.50D" value="1"></el-option>
                        <el-option label="0.75D" value="2"></el-option>
                        <el-option label="1.00D" value="3"></el-option>
                        <el-option label="1.25D" value="4"></el-option>
                        <el-option label="1.50D" value="5"></el-option>
                        <el-option label="1.75D" value="6"></el-option>
                        <el-option label="2.00D" value="7"></el-option>
                        <el-option label="2.25D" value="8"></el-option>
                        <el-option label="2.50D" value="9"></el-option>
                        <el-option label="2.75D" value="10"></el-option>
                        <el-option label="3.00D" value="11"></el-option>
                        <el-option label="3.25D" value="12"></el-option>
                        <el-option label="3.50D" value="13"></el-option>
                        <el-option label="3.75D" value="14"></el-option>
                        <el-option label="4.00D" value="15"></el-option>
                        <el-option label="4.25D" value="16"></el-option>
                        <el-option label="4.50D" value="17"></el-option>
                        <el-option label="4.75D" value="18"></el-option>
                        <el-option label="5.00D" value="19"></el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column prop="adjust" label="调节幅度(范围:0.00D~+22.00D)">
                    <template slot-scope="scope">
                      <el-input v-model="editfucha.amp"></el-input>
                    </template>
                  </el-table-column>
                </el-table-column>
              </el-table>

              <!-- 裸眼和矫正视力 -->
              <el-table :data="nakedEye" border stripe class="mt20">
                <el-table-column label="5m裸眼视力(5分记录法)" align="center">
                  <el-table-column prop="odRight" label="OD(右眼)">
                    <template slot-scope="scope">
                      <el-select v-model="editfucha.nakedrighteyedegree" placeholder="请选择">
                        <el-option
                          v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column prop="osLeft" label="OS(左眼)">
                    <template slot-scope="scope">
                      <el-select v-model="editfucha.nakedlefteyedegree" placeholder="请选择">
                        <el-option
                          v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column prop="ouDouble" label="OU(双眼)">
                    <template slot-scope="scope">
                      <el-select v-model="editfucha.nakedbinoculusdegree" placeholder="请选择">
                        <el-option
                          v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                </el-table-column>

                <el-table-column label="最佳矫正视力(5分记录法)" align="center">
                  <el-table-column prop="odRight1" label="OD(右眼)">
                    <template slot-scope="scope">
                      <el-select v-model="editfucha.correctrighteyedegree" placeholder="请选择">
                        <el-option
                          v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column prop="osLeft1" label="OS(左眼)">
                    <template slot-scope="scope">
                      <el-select v-model="editfucha.correctlefteyedegree" placeholder="请选择">
                        <el-option
                          v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column prop="ouDouble1" label="OU(双眼)">
                    <template slot-scope="scope">
                      <el-select v-model="editfucha.correctbinoculusdegree" placeholder="请选择">
                        <el-option
                          v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                </el-table-column>
              </el-table>

              <!-- 瞳距，内透镜规格 -->
              <el-table :data="tongJuData" border stripe class="mt20">
                <el-table-column  prop="tongju" label="瞳距(单位:mm)">
                  <template slot-scope="scope">
                    <el-input v-model="editfucha.interpupillary"></el-input>
                  </template>
                </el-table-column>
                  <el-table-column label="内置透镜规格(右眼)">
                    <template slot-scope="scope">
                      <el-select v-model="editfucha.neizhitjggright" placeholder="请选择">
                        <el-option
                          v-for="item in neizhitjgglist" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column label="内置透镜规格(左眼)">
                    <template slot-scope="scope">
                      <el-select v-model="editfucha.neizhitjggleft" placeholder="请选择">
                        <el-option
                          v-for="item in neizhitjgglist" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
              </el-table>

              <el-form-item class="mt20">
                <el-button type="primary" @click="clickModify">保存</el-button>
                <el-button type="info" @click="clickreturn2">返回</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <!-- 修改视力复查 end -->

        </el-tabs>
        <!-- Tabs end -->
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  data () {
    return {
      activeName: 'first',
      loading: false,
      selectedPageNo: 1,
      dataListnum: 0,
      value1: '',
      value2: '',
      visionCheckData: [],
      addCustomer: {
        checkname: '',
        inputname: '',
        inputtime: '',
        diopterstate: '0',
        righteyedegree: '0.00',
        rightcolumnmirror: '0.00',
        rightaxial: '0',
        lefteyedegree: '0.00',
        leftcolumnmirror: '0.00',
        leftaxial: '0',
        addtype: '0',
        amp: '0.00',
        nakedrighteyedegree: '0',
        nakedlefteyedegree: '0',
        nakedbinoculusdegree: '0',
        correctrighteyedegree: '0',
        correctlefteyedegree: '0',
        correctbinoculusdegree: '0',
        interpupillary: '',
        neizhitjggright: '8',
        neizhitjggleft: '8'
      },
      editfucha: {
        id: '',
        checkname: '',
        inputname: '',
        inputtime: '',
        diopterstate: '0',
        righteyedegree: '0.00',
        rightcolumnmirror: '0.00',
        rightaxial: '0',
        lefteyedegree: '0.00',
        leftcolumnmirror: '0.00',
        leftaxial: '0',
        addtype: '0',
        amp: '0.00',
        nakedrighteyedegree: '0',
        nakedlefteyedegree: '0',
        nakedbinoculusdegree: '0',
        correctrighteyedegree: '0',
        correctlefteyedegree: '0',
        correctbinoculusdegree: '0',
        interpupillary: '',
        neizhitjggright: '8',
        neizhitjggleft: '8'
      },
      diopterData: [
        {
          rightEye1: '右眼',
          rightEye2: '右眼',
          rightEye3: '右眼',
          leftEye1: '右眼',
          leftEye2: '右眼',
          leftEye3: '右眼'
        }
      ],
      // ADD和调节幅度
      addData: [
        {
          add: 'add',
          adjust: '调节幅度'
        }
      ],
      // 裸眼和矫正视力
      nakedEye: [
        { odRight: '请选择', osLeft: '请选择', ouDouble: '请选择', odRight1: '请选择', osLeft1: '请选择', ouDouble1: '请选择' }
      ],
      tongJuData: [
        { tongju: '请输入', leftEye: '请选择', rightEye: '请选择' }
      ],
      eyedegreelist: [
        { value: '0', label: '请选择' },
        { value: '3.5', label: '3.5' },
        { value: '3.6', label: '3.6' },
        { value: '3.7', label: '3.7' },
        { value: '3.8', label: '3.8' },
        { value: '3.9', label: '3.9' },
        { value: '4.0', label: '4.0' },
        { value: '4.1', label: '4.1' },
        { value: '4.2', label: '4.2' },
        { value: '4.3', label: '4.3' },
        { value: '4.4', label: '4.4' },
        { value: '4.5', label: '4.5' },
        { value: '4.6', label: '4.6' },
        { value: '4.7', label: '4.7' },
        { value: '4.8', label: '4.8' },
        { value: '4.9', label: '4.9' },
        { value: '5.0', label: '5.0' },
        { value: '5.1', label: '5.1' },
        { value: '5.2', label: '5.2' },
        { value: '5.3', label: '5.3' }
      ],
      neizhitjgglist: [
        { value: '8', label: '无' },
        { value: '1', label: 'A' },
        { value: '2', label: 'B' },
        { value: '3', label: 'C' },
        { value: '4', label: 'D' },
        { value: '5', label: 'E' },
        { value: '6', label: 'F' },
        { value: '7', label: '其他' }
      ],
      SubRule_Customer_AddEyeInfo: false,
      SubRule_Customer_ModifyEyeInfo: false,
      Display_ModifyEyeInfo: false,
      SubRule_ExcelFuCha: false,
      parentdata: null
    }
  },
  mounted () {
    var that = this
    Vue.prototype.FunCheckSubRule('SubRule_Customer_AddEyeInfo', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_Customer_AddEyeInfo = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_Customer_ModifyEyeInfo', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_Customer_ModifyEyeInfo = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ExcelFuCha', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ExcelFuCha = true
      }
    })

    this.addCustomer.inputtime = Vue.prototype.FunGetTimeStringLong()
  },
  methods: {
    LoadData (parentdata) {
      this.parentdata = parentdata
      this.apigetfuchanum()
      this.apigetfuchalist()
    },
    backCustomerManagement () {
      this.$emit('triggerFunc', '')
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apigetfuchalist()
    },
    clickreturn1 () {
      this.activeName = 'first'
    },
    clickreturn2 () {
      this.activeName = 'first'
    },
    clickAdd () {
      this.apiaddfucha()
    },
    clickexcel () {
      this.apiExcelFuCha()
    },
    clickm (row) {
      this.editfucha.id = row.Id
      this.editfucha.checkname = row.Checkname
      this.editfucha.inputname = row.Inputname
      this.editfucha.inputtime = row.Inputtime
      this.editfucha.diopterstate = row.Diopterstatei
      this.editfucha.righteyedegree = row.Righteyedegree
      this.editfucha.rightcolumnmirror = row.Rightcolumnmirror
      this.editfucha.rightaxial = row.Rightaxial
      this.editfucha.lefteyedegree = row.Lefteyedegree
      this.editfucha.leftcolumnmirror = row.Leftcolumnmirror
      this.editfucha.leftaxial = row.Leftaxial
      this.editfucha.addtype = row.Addtype
      this.editfucha.amp = row.Amp
      this.editfucha.nakedrighteyedegree = row.Nakedrighteyedegree
      this.editfucha.nakedlefteyedegree = row.Nakedlefteyedegree
      this.editfucha.nakedbinoculusdegree = row.Nakedbinoculusdegree
      this.editfucha.correctrighteyedegree = row.Correctrighteyedegree
      this.editfucha.correctlefteyedegree = row.Correctlefteyedegree
      this.editfucha.correctbinoculusdegree = row.Correctbinoculusdegree
      this.editfucha.interpupillary = row.Interpupillary
      this.editfucha.neizhitjggright = row.Neizhitjggrighti
      this.editfucha.neizhitjggleft = row.Neizhitjgglefti
      this.Display_ModifyEyeInfo = true
      this.activeName = 'three'
    },
    clickModify () {
      this.apieditfucha()
    },
    apigetfuchalist: function () {
      var that = this
      that.loading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassuserid: that.parentdata.params.userid,
        pageno: that.selectedPageNo
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getfuchalist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.visionCheckData = []
            response.data.List.filter((item1, i1) => {
              var add = Vue.prototype.FunGetAdd(item1.Addtype)
              that.visionCheckData.push({ Id: item1.Id, Checkname: item1.Checkname, Inputname: item1.Inputname, Datatype: item1.Datatype, Inputtime: item1.Inputtime, Diopterstate: item1.Diopterstate, Diopterstatei: item1.Diopterstatei, Interpupillary: item1.Interpupillary, Righteyedegree: item1.Righteyedegree, Lefteyedegree: item1.Lefteyedegree, Rightcolumnmirror: item1.Rightcolumnmirror, Leftcolumnmirror: item1.Leftcolumnmirror, Rightaxial: item1.Rightaxial, Leftaxial: item1.Leftaxial, Nakedrighteyedegree: item1.Nakedrighteyedegree, Nakedlefteyedegree: item1.Nakedlefteyedegree, Nakedbinoculusdegree: item1.Nakedbinoculusdegree, Correctrighteyedegree: item1.Correctrighteyedegree, Correctlefteyedegree: item1.Correctlefteyedegree, Correctbinoculusdegree: item1.Correctbinoculusdegree, Neizhitjggright: item1.Neizhitjggright, Neizhitjggleft: item1.Neizhitjggleft, Neizhitjggrighti: item1.Neizhitjggrighti, Neizhitjgglefti: item1.Neizhitjgglefti, Addtype: item1.Addtype, Add: add, Amp: item1.Amp, Adminname: item1.Adminname })
            })
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.loading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.loading = false
        })
    },
    apigetfuchanum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassuserid: that.parentdata.params.userid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getfuchanum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiaddfucha: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassuserid: that.parentdata.params.userid,
        checkname: that.addCustomer.checkname,
        inputname: that.addCustomer.inputname,
        diopterstate: that.addCustomer.diopterstate,
        righteyedegree: that.addCustomer.righteyedegree,
        rightcolumnmirror: that.addCustomer.rightcolumnmirror,
        rightaxial: that.addCustomer.rightaxial,
        lefteyedegree: that.addCustomer.lefteyedegree,
        leftcolumnmirror: that.addCustomer.leftcolumnmirror,
        leftaxial: that.addCustomer.leftaxial,
        addtype: that.addCustomer.addtype,
        amp: that.addCustomer.amp,
        nakedrighteyedegree: that.addCustomer.nakedrighteyedegree,
        nakedlefteyedegree: that.addCustomer.nakedlefteyedegree,
        nakedbinoculusdegree: that.addCustomer.nakedbinoculusdegree,
        correctrighteyedegree: that.addCustomer.correctrighteyedegree,
        correctlefteyedegree: that.addCustomer.correctlefteyedegree,
        correctbinoculusdegree: that.addCustomer.correctbinoculusdegree,
        interpupillary: that.addCustomer.interpupillary,
        neizhitjggright: that.addCustomer.neizhitjggright,
        neizhitjggleft: that.addCustomer.neizhitjggleft,
        inputtime: that.addCustomer.inputtime
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Addfucha, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.addCustomer.checkname = ''
            that.addCustomer.inputname = ''
            that.addCustomer.inputtime = ''
            that.addCustomer.diopterstate = '0'
            that.addCustomer.righteyedegree = '0.00'
            that.addCustomer.rightcolumnmirror = '0.00'
            that.addCustomer.rightaxial = '0'
            that.addCustomer.lefteyedegree = '0.00'
            that.addCustomer.leftcolumnmirror = '0.00'
            that.addCustomer.leftaxial = '0'
            that.addCustomer.addtype = '0'
            that.addCustomer.amp = '0.00'
            that.addCustomer.nakedrighteyedegree = '0'
            that.addCustomer.nakedlefteyedegree = '0'
            that.addCustomer.nakedbinoculusdegree = '0'
            that.addCustomer.correctrighteyedegree = '0'
            that.addCustomer.correctlefteyedegree = '0'
            that.addCustomer.correctbinoculusdegree = '0'
            that.addCustomer.interpupillary = ''
            that.addCustomer.neizhitjggright = '8'
            that.addCustomer.neizhitjggleft = '8'

            that.activeName = 'first'
            that.apigetfuchanum()
            that.apigetfuchalist()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apieditfucha: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        fuchaid: that.editfucha.id,
        checkname: that.editfucha.checkname,
        inputname: that.editfucha.inputname,
        diopterstate: that.editfucha.diopterstate,
        righteyedegree: that.editfucha.righteyedegree,
        rightcolumnmirror: that.editfucha.rightcolumnmirror,
        rightaxial: that.editfucha.rightaxial,
        lefteyedegree: that.editfucha.lefteyedegree,
        leftcolumnmirror: that.editfucha.leftcolumnmirror,
        leftaxial: that.editfucha.leftaxial,
        addtype: that.editfucha.addtype,
        amp: that.editfucha.amp,
        nakedrighteyedegree: that.editfucha.nakedrighteyedegree,
        nakedlefteyedegree: that.editfucha.nakedlefteyedegree,
        nakedbinoculusdegree: that.editfucha.nakedbinoculusdegree,
        correctrighteyedegree: that.editfucha.correctrighteyedegree,
        correctlefteyedegree: that.editfucha.correctlefteyedegree,
        correctbinoculusdegree: that.editfucha.correctbinoculusdegree,
        interpupillary: that.editfucha.interpupillary,
        neizhitjggright: that.editfucha.neizhitjggright,
        neizhitjggleft: that.editfucha.neizhitjggleft,
        inputtime: that.editfucha.inputtime
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Editfucha, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.Display_ModifyEyeInfo = false
            that.apigetfuchalist()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiExcelFuCha: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassuserid: that.parentdata.params.userid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ExcelFuCha, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.$confirm('是否跳转到文件管理，查看导出情况?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              showCancelButton: true,
              type: 'warning'
            }).then(() => {
              that.$router.push({ path: '/FileManagementExcel' })
            })
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
